/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const productCardSX: SxProps = {
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: 'transparent',
};
